import { noop } from '@direct-frontend/stdlib';
import { createApi, createBaseQuery } from '@adv-frontend/modules-query';
import { apiV1Request } from '#shared/api/requests';
import {
    type OpenApiGetMerchantDomainStatusRequest,
    type OpenApiGetMerchantDomainStatusResponseSuccess,
    type OpenApiGetMerchantInfoRequest,
    type OpenApiGetMerchantInfoResponseSuccess,
    type OpenApiMerchantRegisterDomainRequest,
    type OpenApiMerchantRegisterDomainResponseSuccess,
    type OpenApiMerchantRegisterFeedRequest,
    type OpenApiMerchantRegisterFeedResponseSuccess,
} from '#shared/api/schema';

const yandexMerchantsApi = createApi({
    name: 'entities/integration/api/yandexMerchantsApi',
    baseQuery: createBaseQuery(apiV1Request),
    endpoints: (builder) => {
        return {
            getYandexMerchantsInfo: builder.query<OpenApiGetMerchantInfoResponseSuccess, OpenApiGetMerchantInfoRequest>(
                {
                    query: () => {
                        return {
                            url: '/merchant/info',
                            method: 'GET',
                        };
                    },
                }
            ),
            getYandexMerchantsRegistrationStatus: builder.query<
                OpenApiGetMerchantDomainStatusResponseSuccess,
                OpenApiGetMerchantDomainStatusRequest
            >({
                query: () => {
                    return {
                        url: '/merchant/domain/register',
                        method: 'GET',
                    };
                },
            }),
            connectYandexMerchants: builder.mutation<
                OpenApiMerchantRegisterDomainResponseSuccess,
                OpenApiMerchantRegisterDomainRequest
            >({
                query: () => {
                    return {
                        url: '/merchant/domain/register',
                        method: 'POST',
                        body: {},
                    };
                },
                onQueryStarted: async (_, { queryFulfilled }) => {
                    const queryFulfilledResult = await queryFulfilled.catch(noop);

                    if (queryFulfilledResult === undefined) {
                        return;
                    }

                    const { data: newData } = queryFulfilledResult;

                    yandexMerchantsApi.endpoints.getYandexMerchantsRegistrationStatus.updateQueryData(
                        undefined,
                        (oldData) => {
                            return { ...oldData, ...newData };
                        }
                    );
                },
            }),
            registerFeedYandexMerchants: builder.mutation<
                OpenApiMerchantRegisterFeedResponseSuccess,
                OpenApiMerchantRegisterFeedRequest
            >({
                query: () => {
                    return {
                        url: '/merchant/feed/register',
                        method: 'POST',
                        body: {},
                    };
                },
            }),
        };
    },
});

export const useIntegrationGetYandexMerchantsRegistrationStatus =
    yandexMerchantsApi.useGetYandexMerchantsRegistrationStatusQuery;
export const useIntegrationGetYandexMerchantsInfo = yandexMerchantsApi.useGetYandexMerchantsInfoQuery;
export const connectIntegrationYandexMerchants = yandexMerchantsApi.endpoints.connectYandexMerchants.mutate;
export const registerFeedIntegrationYandexMerchants = yandexMerchantsApi.endpoints.registerFeedYandexMerchants.mutate;
